import { render, staticRenderFns } from "./PackagingsTab.vue?vue&type=template&id=45ce77f2&scoped=true"
import script from "./PackagingsTab.vue?vue&type=script&lang=js"
export * from "./PackagingsTab.vue?vue&type=script&lang=js"
import style0 from "./PackagingsTab.vue?vue&type=style&index=0&id=45ce77f2&prod&scoped=true&lang=css"
import style1 from "./PackagingsTab.vue?vue&type=style&index=1&id=45ce77f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce77f2",
  null
  
)

export default component.exports